import { createContext } from 'react';

export const TextCatContext = createContext({
  categories: [],
  allCategories: [],
  handleGetSettingData:()=>{},
  setting:{},
  // ***************************
  isModalVisible: false,
  setIsModalVisible: () => {},
  isErrorModalVisible: false,
  setIsErrorModalVisible: () => {},
  navbarArray: [],
  setNavbarArray: () => {},
  alarmSocket: [],
  setAlarmSocket: () => {},
  closeAlarm: [],
  setCloseAlarm: () => {},
  alarmHappenSocket: [],
  setAlarmHappenSocket: () => {},
  socketCount: 0,
  setSocketCount: () => {},
  playAlarm: false,
  setPlayAlarm: () => {},
});
